// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2FEhF","alert":"SettungsInbox_alert__1uT8l"};